// extracted by mini-css-extract-plugin
export var hidden = "_q6-1";
export var visible = "_q6-0";